<sm-title-bar [headerCustomTemplate]="addButton" [backLocation]="true" pageTitle="Service reminder">
    <ng-template #addButton>
      <div class="create_btn_sd">
        <button mat-icon-button color="primary" (click)="opennewreminder()">
            <mat-icon>add</mat-icon> 
        </button> 
    </div>
    </ng-template>
  </sm-title-bar>

  <div class="bradcamp_inventory">
    <div class="over_sectionkl">
      <div class="overall_count_s">
      <p>Active</p>
      <h3>212</h3>
      </div>
      <div class="overall_count_s" style="border-right: none !important;">
      <p>Inactive/paused</p>
      <h3>178</h3>
      </div>
    </div>
    <div class="col-sm-6">
    </div>
  </div>


<div class="purchase_list">
  <div class="row g-3">
    <!-- CARD START -->
    <div class="col-12 col-md-6 col-lg-4">
      <mat-card class="reminder-card">
        <div class="card-top">
          <div class="initial-circle active">H</div>
          <!-- <div class="status-badge active">Active</div> -->
          <button mat-icon-button [matMenuTriggerFor]="menu1" class="menu-btn">
            <mat-icon>more_vert</mat-icon>
          </button>
            <div class="card-body">
          <h3 class="title">Hair Spa</h3>
          <p class="info">
            Feb 5, 2026 • 10:30 AM
          </p>
          <p class="notes">
            You Have A Scheduled Session.
          </p>
          <p class="info">
            Recurring / 30 Days
          </p>
          <p class="created">
            Created on Jan 10, 2026
          </p>
        </div>
        </div>
      
      </mat-card>
    </div>
        <div class="col-12 col-md-6 col-lg-4">
      <mat-card class="reminder-card">
        <div class="card-top">
          <div class="initial-circle active">F</div>
          <!-- <div class="status-badge active">Active</div> -->
          <button mat-icon-button [matMenuTriggerFor]="menu1" class="menu-btn">
            <mat-icon>more_vert</mat-icon>
          </button>
            <div class="card-body">
          <h3 class="title">Facial cleanup</h3>
          <p class="info">
            Feb 5, 2026 • 10:30 AM
          </p>
          <p class="notes">
            Facial cleanup appointment reminder.
          </p>
          <p class="info">
            Recurring / 30 Days
          </p>
          <p class="created">
            Created on Jan 10, 2026
          </p>
        </div>
        </div>
      
      </mat-card>
    </div>
        <div class="col-12 col-md-6 col-lg-4">
      <mat-card class="reminder-card">
        <div class="card-top">
          <div class="initial-circle active">S</div>
          <!-- <div class="status-badge active">Active</div> -->
          <button mat-icon-button [matMenuTriggerFor]="menu1" class="menu-btn">
            <mat-icon>more_vert</mat-icon>
          </button>
            <div class="card-body">
          <h3 class="title">Special diet</h3>
          <p class="info">
            Feb 5, 2026 • 10:30 AM
          </p>
          <p class="notes">
           You Need To Visit Gym.
          </p>
          <p class="info">
            Recurring / 30 Days
          </p>
          <p class="created">
            Created on Jan 10, 2026
          </p>
        </div>
        </div>
      
      </mat-card>
    </div>
    <!-- CARD END -->

  </div>
</div>

<!-- MENUS -->
<mat-menu #menu1="matMenu">
  <button mat-menu-item><mat-icon class="material-icons-outlined">edit</mat-icon>Edit</button>
  <button mat-menu-item><mat-icon class="material-icons-outlined">pause</mat-icon>Pause</button>
  <button mat-menu-item><mat-icon class="material-icons-outlined">delete</mat-icon>Delete</button>

</mat-menu>

<mat-menu #menu2="matMenu">
  <button mat-menu-item><mat-icon class="material-icons-outlined">edit</mat-icon>Edit</button>
  <button mat-menu-item><mat-icon class="material-icons-outlined">play_arrow</mat-icon>Resume</button>
  <button mat-menu-item><mat-icon class="material-icons-outlined">delete</mat-icon>Delete</button>

</mat-menu>
